import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const storedLanguage = typeof window !== 'undefined'
    ? window.localStorage.getItem('language')
    : null;

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: storedLanguage ? storedLanguage.toLowerCase() : 'id',
        fallbackLng: 'id',
        debug: true,
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json', // Path to load translations
        },
    });

export default i18n;
